import BlankImage from "@pathwright/ui/src/components/blank/BlankImage"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useLicensorsQuery } from "@pathwright/graphql-client/src/generated"
import {
  LicensorLink,
  massageLicensorsQueryData
} from "../../path/create/Licensors"
import SchoolQuery from "../../school/graphql/SchoolQuery"

export const LicensorLibraryPickerBlankSlate = ({
  licensorId,
  onOpenStore
}) => {
  const { t } = useTranslate()

  if (!licensorId) return null

  return (
    <SchoolQuery id={licensorId}>
      {({ school: licensor }) =>
        !!licensor && (
          <BlankSlate
            illustration={<BlankImage image="library" />}
            heading={t("Nothing is in your library")}
            body={t(
              `Looking for something to teach? Get ready-to-teach curriculum from {{ licensorSchoolName }}`,
              {
                licensorSchoolName: licensor.name
              }
            )}
            primaryAction={{
              children: t("Find Curriculum"),
              onClick: () => onOpenStore && onOpenStore(),
              to: `/library/store/${licensor.id}/`
            }}
          />
        )
      }
    </SchoolQuery>
  )
}

const LicensorLibraryPickerPrompt = ({ licensorId, onOpenStore }) => {
  const licensorsQuery = useLicensorsQuery({
    skip: !licensorId
  })
  const licensors = massageLicensorsQueryData(licensorsQuery.data)
  const licensor = licensors.find((l) => l.id === licensorId)

  return licensor ? (
    <LicensorLink licensor={licensor} onClick={onOpenStore} />
  ) : null
}

LicensorLibraryPickerPrompt.displayName = "LicensorLibraryPickerPrompt"

export default LicensorLibraryPickerPrompt
